import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import useModalEffect from '../../../hooks/useModalEffect';

const ViewChartOfAccount = ({ isOpen, onClose, data }) => {
  useModalEffect(isOpen);
  ;


  if (!data) return null;

  return (
    <>
      <style>{`
        #modal-view-chart-of-account .inv-footer {
          border-top: 1px solid #e9ecef !important;
          background: #fff;
          padding: 1rem 1.5rem;
          display: flex; align-items: center; justify-content: flex-end; gap: 0.6rem;
          flex-shrink: 0;
        }
      `}</style>
      {isOpen && ReactDOM.createPortal(<div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />, document.body)}
      <div className={`modal modal-blur fade${isOpen ? ' show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }} id="modal-view-chart-of-account" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-md modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">View Chart of Account</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="row mb-3"><div className="col-4 fw-bold">Code</div><div className="col-8">{data.accountCode || '-'}</div></div>
            <div className="row mb-3"><div className="col-4 fw-bold">Name</div><div className="col-8">{data.accountName || '-'}</div></div>
            <div className="row mb-3"><div className="col-4 fw-bold">Type</div><div className="col-8">{data.accountType || '-'}</div></div>
            <div className="row mb-3"><div className="col-4 fw-bold">Owner</div><div className="col-8">{data.owner || 'Finance'}</div></div>
            <div className="row mb-3"><div className="col-4 fw-bold">Description</div><div className="col-8">{data.description || '-'}</div></div>
            <div className="row mb-3"><div className="col-4 fw-bold">Create Date</div><div className="col-8">{data.cdate ? new Date(data.cdate).toLocaleString() : '-'}</div></div>
          </div>
          <div className="inv-footer">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

ViewChartOfAccount.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object
};

export default ViewChartOfAccount;
